import { z } from 'zod'
import type { Update } from './generate'

export const baseSchema = z.object({
  id: z.string(),
  deletedAt: z.string().nullish(),
})

export type { Update }
